import {GraphQLError} from 'graphql';

const loggedOutErrors = [
  'You are not authorized to access this data',
  'You must be logged in to execute this query',
];

const hasLoggedOutErrorMessage = (error: Error): boolean => {
  if (!error.message) return false;

  return loggedOutErrors.some(errorMessage => error.message.indexOf(errorMessage) >= 0);
};

type ErrorType = readonly GraphQLError[] | Error;
const isLoggedOutError = (error?: ErrorType): boolean => {
  if (!error) return false;

  if (error instanceof Error) return hasLoggedOutErrorMessage(error);

  return error.some(e => hasLoggedOutErrorMessage(e));
};

export default isLoggedOutError;
